const apiHost = process.env.REACT_APP_DATABASE_URL
const privateKey = process.env.REACT_APP_PRIVATE_KEY
const geoAPI = process.env.REACT_APP_GEO_API

export default {
	async fetchDeals() {
		try {
			const response = await fetch(apiHost + '/deals.json?auth=' + privateKey + '&print=pretty')
			const responseJson = await response.json()
			return responseJson
		} catch(error) {
			console.log(error)
		}
	},

	fetchGeoCode(type,location) {

		return fetch('https://maps.googleapis.com/maps/api/geocode/json?' + type + '=' + location + "&key=" + geoAPI)

	}
}



// WEBPACK FOOTER //
// ./src/ajax.js